<section class="form">
  <form [formGroup]="formTable" class="form_table" (ngSubmit)="addData()">
    <div
      class="style-input-default input_table"
      data-text="Cuenta origen *"
      [ngClass]="{ error: verificateInput('cuenta_origen') }"
    >
      <input
        type="text"
        placeholder="Cuenta origen"
        formControlName="cuenta_origen"
        onlyNumber
      />
    </div>
    <div
      class="style-input-default input_table"
      data-text="Cuenta destino *"
      [ngClass]="{ error: verificateInput('cuenta_destino') }"
    >
      <input
        type="text"
        placeholder="Cuenta destino"
        formControlName="cuenta_destino"
        onlyNumber
      />
    </div>
    <div
      class="style-input-default input_table"
      data-text="Monto *"
      [ngClass]="{ error: verificateInput('monto') }"
    >
      <input type="text" Currency placeholder="Monto" formControlName="monto" />
    </div>
    <div
      class="style-input-default input_table"
      data-text="Fecha *"
      [ngClass]="{ error: verificateInput('fecha') }"
    >
      <input
        type="datetime-local"
        placeholder="Fecha"
        formControlName="fecha"
      />
    </div>
    <!--<div class="style-input-default input_table" data-text="Hora *" [ngClass]="{error: verificateInput('hora')}">
      <input  placeholder="Hora" formControlName="hora">
    </div>-->
    <button
      type="submit"
      *ngIf="!status"
      [disabled]="formTable.invalid || submit"
    >
      <i class="fas fa-plus"></i>
    </button>
  </form>
</section>

<div class="task_content_table">
  <table mat-table #dataTable [dataSource]="dataSource" class="task_table">
    <ng-container matColumnDef="cuenta_origen">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Cuenta origen
      </th>
      <td mat-cell *matCellDef="let element">{{ element.cuenta_origen }}</td>
    </ng-container>

    <ng-container matColumnDef="cuenta_destino">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Cuenta destino
      </th>
      <td mat-cell *matCellDef="let element">{{ element.cuenta_destino }}</td>
    </ng-container>

    <ng-container matColumnDef="monto">
      <th class="header-options" mat-header-cell *matHeaderCellDef>Monto</th>
      <td mat-cell *matCellDef="let element">{{ element.monto }}</td>
    </ng-container>

    <ng-container matColumnDef="fecha">
      <th class="header-options" mat-header-cell *matHeaderCellDef>Fecha</th>
      <td mat-cell *matCellDef="let element">
        {{ element.fecha | date : "d/M/yy, h:mm a" }}
      </td>
    </ng-container>

    <!--<ng-container matColumnDef="hora">
      <th class="header-options" mat-header-cell *matHeaderCellDef>Hora</th>
      <td mat-cell *matCellDef="let element"> {{ element.hora }} </td>
    </ng-container>-->

    <ng-container matColumnDef="opciones">
      <th class="header-options" mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div class="options">
          <button class="delete" (click)="removerCuenta(i)">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<mat-paginator
  [pageSizeOptions]="[5, 10, 25, 50, 100]"
  [pageSize]="5"
  [showFirstLastButtons]
></mat-paginator>
